module.exports = __webpack_public_path__ + "assurant.png?a066abbeef6fa4bd75bab800995a7f0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/assurant.png
// module id = 177
// module chunks = 0